import { Observable, map } from 'rxjs';
import { Injectable } from '@angular/core';
import { NgxIndexedDBService } from 'ngx-indexed-db';

import { SearchData } from '@shared/base-search-bar/entities/search-data';
import { travelSearchDB, travelSearchDBData } from '@shared/base-search-bar/constants/search-db.const';

@Injectable()
export class StorageServices {

  private readonly SearchDataId = 1;

  constructor(
    private readonly dbService: NgxIndexedDBService,
  ) { }

  public save(data: SearchData): Observable<SearchData> {
    return this.dbService.update(travelSearchDB, { id: this.SearchDataId, [travelSearchDBData]: data }).pipe(
      map(((searchDB: { id: number, [travelSearchDBData]: SearchData }) => {
        return searchDB?.[travelSearchDBData];
      }))
    );
  }

  public load(): Observable<SearchData> {
    return this.dbService.getByKey(travelSearchDB, this.SearchDataId).pipe(
      map(((searchDB: { id: number, [travelSearchDBData]: SearchData }) => {
        return searchDB?.[travelSearchDBData];
      }))
    );
  }
}
